// extracted by mini-css-extract-plugin
module.exports = {"Prices2":"prices2-module--Prices2--1cwKs","included":"prices2-module--included--2wB3k"};